var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scaler",staticClass:"i-scaler",on:{"click":_vm.openScaler}},[_c('div',{staticClass:"content"},[_c('i-scaler-item',{attrs:{"type":_vm.datas.type,"datas":_vm.datas.data}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }